// This icon file is generated automatically.
var PSnippetsOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12 .75h-1.69V.12A.13.13 0 0010.2 0H9.3a.13.13 0 00-.12.13v.62H6.8V.12A.13.13 0 006.7 0H5.8a.13.13 0 00-.12.13v.62H4a.5.5 0 00-.5.5v1.88H2a.5.5 0 00-.5.5v9.87c0 .28.22.5.5.5h8a.5.5 0 00.5-.5V12H12a.5.5 0 00.5-.5V1.25a.5.5 0 00-.5-.5zM9.37 12.88H2.63V4.24h3.4v2.72c0 .34.28.62.63.62h2.71v5.29zm0-6.29H7.04V4.25l2.34 2.34zm2 4.29h-.87V6.12l-3-3H4.62V1.88H5.7v.5c0 .07.05.13.12.13h.88c.07 0 .12-.06.12-.13v-.5H9.2v.5c0 .07.05.13.12.13h.88c.07 0 .12-.06.12-.13v-.5h1.06v9z", "fill-rule": "nonzero" } }] }, "name": "p-snippets", "theme": "outlined" };
export default PSnippetsOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PSnippetsOutlined.js
// module id = 3640
// module chunks = 0